export default defineNuxtPlugin(() => { useAppearance(); });
